var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toasted-bounce"}},[(_vm.show)?_c('div',{class:_vm.className,on:{"click":function($event){$event.preventDefault();return _vm.bye.apply(null, arguments)}}},[(!!_vm.message)?[_vm._v(_vm._s(_vm.message))]:_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }